export default __webpack_public_path__ + "static/media/logoSecond.de9800ad.png";